'use client';

import ReactPlayer from 'react-player';

import { tw } from '../../utils';

interface TileVideoProps {
  src: string;
  hasFooter: boolean;
}

export const TileVideo: React.FC<TileVideoProps> = ({
  src,
  hasFooter = false,
}: TileVideoProps) => {
  return (
    <div className='h-full w-full'>
      <ReactPlayer
        muted={true}
        loop
        playing
        playsinline
        height='100%'
        width='100%'
        className={tw(
          'block !aspect-square h-full w-full overflow-hidden',
          hasFooter ? 'rounded-t-[15px]' : 'rounded-[15px]',
        )}
        url={src}
      />
    </div>
  );
};
